import React from 'react'
import styles from './ReportButtons.module.sass'
import Button from '@mui/material/Button'
import usePiwik from 'src/hooks/usePiwik'
import PropTypes from 'prop-types'
import { useSelector, shallowEqual } from 'react-redux'
import { getConfig } from 'src/features/config/ConfigSelector'
import cx from 'classnames'

const UpcomingAndAnonymous = ({
  openModal,
  articleId,
  productCode,
  setNotifySettings = () => {}
}) => {
  const { handleTrackingWithArticleIdProp } = usePiwik()
  const notifyMeSettings =
    useSelector(getConfig('notify_me_settings'), shallowEqual) || {}
  const newsletterUuid = notifyMeSettings?.newsletter_notify_me?.newsletter_uuid

  const handleNotifyButtonClick = () => {
    openModal('notify-me', 'notify-me', true)
    setNotifySettings({
      newsletterUuid,
      articleId: productCode
    })
  }

  const handleContactButtonClick = () => {
    handleTrackingWithArticleIdProp(
      'article',
      'button-click',
      'contact-me-about-this-report',
      articleId
    )
    openModal('contact-me-about-this-report', false, 'notify-me')
  }

  return (
    <>
      <Button
        className={cx(styles.notifyButton, styles.notifyButtonAnon)}
        onClick={handleNotifyButtonClick}
        variant="contained"
      >
        Notify me of this report
      </Button>
      <Button
        className={cx(styles.contactButton, styles.contactButtonAnon)}
        onClick={handleContactButtonClick}
        variant="contained"
      >
        Contact me about this report
      </Button>
    </>
  )
}

UpcomingAndAnonymous.propTypes = {
  openModal: PropTypes.func,
  articleId: PropTypes.string,
  productCode: PropTypes.string,
  setNotifySettings: PropTypes.func
}

export default UpcomingAndAnonymous
